import { render } from "./issuesDisplay.vue?vue&type=template&id=fc91304a&scoped=true"
import script from "./issuesDisplay.vue?vue&type=script&lang=js"
export * from "./issuesDisplay.vue?vue&type=script&lang=js"

import "./issuesDisplay.vue?vue&type=style&index=0&id=fc91304a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc91304a"]])

export default __exports__